import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
function VerticalGradientText({
  children,
  className
}: GeneralPropsType) {
  return <p className={clsx(styles.container, className)} data-sentry-component="VerticalGradientText" data-sentry-source-file="index.tsx">{children}</p>;
}
export default VerticalGradientText;